var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99978 17.002C9.99978 17.002 15.8316 13.5826 15.8316 8.77126C15.8316 5.55045 13.2206 2.93945 9.99978 2.93945C6.77897 2.93945 4.16797 5.55045 4.16797 8.77126C4.16797 13.5826 9.99978 17.002 9.99978 17.002Z",
    stroke: "#807A98",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1206 8.68038C12.1206 9.85167 11.171 10.8012 9.99974 10.8012C8.82842 10.8012 7.87891 9.85167 7.87891 8.68038C7.87891 7.50909 8.82842 6.55955 9.99974 6.55955C11.171 6.55955 12.1206 7.50909 12.1206 8.68038Z",
    stroke: "#807A98",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.c989092849cb27c40572b9b7185d01f4.svg";
export { ForwardRef as ReactComponent };